import React from 'react';
import ReactLoading from "react-loading";

function Loader({ text = "Cargando..." }) {
    return (
        <div
            className="loading-g d-vertical-center loading-btn mb-5"
            style={{ height: "calc(100vh - 72px)" }}
        >
            <div>
                <ReactLoading
                    type="cylon"
                    color="#000"
                    width={"100%"}
                    height={"58px"}
                />
                <span>{text}</span>
            </div>
        </div>
    );
}

export default Loader;
